
import React from 'react';

const GTAAds: React.FC = () => {
  return (
    <div className="w-full max-w-4xl px-4 grid grid-cols-1 md:grid-cols-3 gap-6 animate-in slide-in-from-bottom-20 duration-1000">
      {/* Biki Vibecode Agency Ad */}
      <a 
        href="https://biki90.nl" 
        target="_blank" 
        rel="noopener noreferrer"
        className="group relative block bg-pink-500 border-4 border-black p-4 transform hover:-rotate-1 hover:scale-105 transition-all shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-x-1 active:translate-y-1 overflow-hidden"
      >
        {/* Neon Grid Background Effect */}
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 0)', backgroundSize: '8px 8px' }}></div>
        
        <div className="absolute -top-1 -left-4 bg-cyan-400 border-2 border-black px-2 py-0.5 font-black text-[10px] -rotate-12 z-20 shadow-md uppercase tracking-tighter">
          No Bullshit
        </div>
        
        <div className="absolute -bottom-2 -right-1 bg-yellow-300 border-2 border-black px-2 py-1 font-black text-sm rotate-6 z-20 group-hover:scale-110 transition-transform uppercase">
          Raw!
        </div>

        <div className="relative z-10">
          <h3 className="text-white font-black text-3xl italic tracking-tighter leading-none mb-3 drop-shadow-[3px_3px_0px_rgba(0,0,0,1)] flex flex-col uppercase">
            <span>BIKI</span>
            <span className="text-cyan-300 text-2xl">VIBECODE</span>
          </h3>
          
          <div className="flex items-center space-x-2 mb-3 bg-black/20 p-1.5 border-2 border-black rotate-1">
             <span className="text-xl">⚡</span>
             <p className="text-white font-black text-[10px] uppercase tracking-widest italic">
               Digitale Dominantie
             </p>
          </div>
          
          <div className="bg-black text-cyan-300 text-center py-2 font-black text-lg uppercase border-2 border-cyan-300 group-hover:bg-white group-hover:text-black transition-all italic">
            BIKI90.NL
          </div>
        </div>
      </a>

      {/* Los Eindjes FM Ad */}
      <a 
        href="https://EindjeFM.nl" 
        target="_blank" 
        rel="noopener noreferrer"
        className="group relative block bg-orange-600 border-4 border-black p-4 transform hover:rotate-1 hover:scale-105 transition-all shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-x-1 active:translate-y-1 overflow-hidden"
      >
        <div className="absolute top-0 right-0 p-1.5 bg-red-600 text-white text-[9px] font-black border-l-2 border-b-2 border-black z-20 uppercase tracking-tighter">
          FM 108.0 MHZ
        </div>
        
        {/* Lightning Bolts */}
        <div className="absolute top-6 left-0 text-yellow-400 text-4xl opacity-20 animate-pulse">⚡</div>

        <div className="relative z-10">
          <div className="flex items-center space-x-3 mb-3">
              <div className="bg-white border-2 border-black p-1.5 rotate-[-5deg] group-hover:rotate-6 transition-transform shadow-md">
                <span className="text-4xl">📻</span>
              </div>
              <h3 className="text-white font-black text-3xl tracking-tighter italic leading-none drop-shadow-[3px_3px_0px_rgba(0,0,0,1)] uppercase">
                EINDJE <span className="text-yellow-400 text-2xl">FM</span>
              </h3>
          </div>
          
          <div className="bg-black border-2 border-yellow-400 p-1.5 mb-4 -rotate-1 shadow-md">
            <p className="text-yellow-400 font-black text-[10px] uppercase text-center italic tracking-tight">
              Signaal Zonder Grens
            </p>
          </div>

          <div className="bg-white border-2 border-black text-black text-center py-2 font-black text-lg uppercase group-hover:bg-black group-hover:text-white group-hover:border-white transition-all">
            STSTEMA ON!
          </div>
        </div>
      </a>

      {/* Ral Beats Ad */}
      <a 
        href="https://Ralbeats.com" 
        target="_blank" 
        rel="noopener noreferrer"
        className="group relative block bg-blue-800 border-4 border-black p-4 transform hover:-rotate-1 hover:scale-105 transition-all shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-x-1 active:translate-y-1 overflow-hidden"
      >
        {/* Caution Stripes Background */}
        <div className="absolute top-0 left-0 w-full h-2 bg-yellow-400 -rotate-1 opacity-40 flex overflow-hidden">
          {[...Array(15)].map((_, i) => <div key={i} className="w-4 h-full bg-black ml-2 skew-x-12"></div>)}
        </div>

        <div className="absolute -left-4 bottom-8 w-16 h-16 bg-red-600 rounded-full border-4 border-black flex items-center justify-center text-white font-black text-lg rotate-[-25deg] group-hover:rotate-0 transition-transform shadow-xl z-20 uppercase italic">
          Noise!
        </div>
        
        <div className="relative z-10 pt-2">
          <h3 className="text-yellow-300 font-black text-3xl tracking-tight leading-none mb-1.5 drop-shadow-[3px_3px_0px_rgba(0,0,0,1)] uppercase">
            RAL <br/> BEATS
          </h3>
          
          <div className="mb-4 flex flex-wrap gap-1.5">
            <span className="bg-white text-black px-1.5 py-0.5 text-[8px] font-black uppercase border border-black tracking-tighter">808 ANARCHY</span>
            <span className="bg-black text-white px-1.5 py-0.5 text-[8px] font-black uppercase border border-white tracking-tighter">CERTIFIED</span>
          </div>

          <p className="text-white font-black text-[10px] uppercase mb-4 tracking-tighter leading-tight italic bg-black/60 p-1.5 border-l-2 border-red-600">
            RAW SAMPLES & HEAVY MASTERING
          </p>
          
          <div className="bg-yellow-300 text-black text-center py-2 font-black text-lg uppercase border-2 border-black group-hover:invert transition-all italic">
            GET BEATS
          </div>
        </div>
      </a>
    </div>
  );
};

export default GTAAds;
